import { hideService } from '../../utils/hideService';

export const keysMap = {
  withExpertAndProxy: 'withExpertAndProxy',
  withExpert: 'withExpert',
  withoutExpertAndProxy: 'withoutExpertAndProxy',
  withoutExpert: 'withoutExpert',
  unavailable: 'unavailable',
};

export const keyToId = {
  [keysMap.unavailable]: 0,
  [keysMap.withExpertAndProxy]: 1,
  [keysMap.withExpert]: 2,
  [keysMap.withoutExpertAndProxy]: 3,
  [keysMap.withoutExpert]: 4,
};

export const valueToContent = {
  [keyToId[keysMap.unavailable]]: 'Без услуги',
  [keyToId[keysMap.withExpertAndProxy]]: 'С экспертом, по доверенности',
  [keyToId[keysMap.withExpert]]: 'С экспертом, без доверенности',
  [keyToId[keysMap.withoutExpertAndProxy]]: 'Без эксперта, по доверенности',
  [keyToId[keysMap.withoutExpert]]: 'Без эксперта, без доверенности',
};

export const roomByAcceptanceServices = {
  extract: (room) => {
    if (!room.recordInfo || hideService(room)) {
      return keyToId[keysMap.unavailable];
    }

    const { withExpert, byProxy } = room.recordInfo;

    if (withExpert && byProxy) {
      return keyToId[keysMap.withExpertAndProxy];
    }

    if (withExpert && !byProxy) {
      return keyToId[keysMap.withExpert];
    }

    if (!withExpert && byProxy) {
      return keyToId[keysMap.withoutExpertAndProxy];
    }

    return keyToId[keysMap.withoutExpert];
  },
};
